import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const dismissCircleFilledVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type DismissCircleFilledProps = {
  width?: string | number;
  height?: string | number;
  viewBox?: string;
  fill?: string;
} & React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof dismissCircleFilledVariants>;

const DismissCircleFilled = React.forwardRef<
  SVGSVGElement,
  DismissCircleFilledProps
>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          dismissCircleFilledVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox ?? '0 0 24 24'}
        width={width}
        {...props}
      >
        <path d="M12 2.40002C14.5461 2.40002 16.9879 3.41145 18.7882 5.2118C20.5886 7.01215 21.6 9.45395 21.6 12C21.6 14.5461 20.5886 16.9879 18.7882 18.7882C16.9879 20.5886 14.5461 21.6 12 21.6C9.45392 21.6 7.01212 20.5886 5.21178 18.7882C3.41143 16.9879 2.4 14.5461 2.4 12C2.4 9.45395 3.41143 7.01215 5.21178 5.2118C7.01212 3.41145 9.45392 2.40002 12 2.40002ZM9.372 8.53682C9.25643 8.45696 9.11649 8.42019 8.97659 8.43291C8.83668 8.44562 8.70568 8.50703 8.6064 8.60642L8.5368 8.68922C8.45694 8.8048 8.42016 8.94473 8.43288 9.08464C8.4456 9.22454 8.50701 9.35555 8.6064 9.45482L11.1504 12L8.6064 14.5452L8.5368 14.6292C8.45726 14.7447 8.42067 14.8844 8.43338 15.024C8.44609 15.1636 8.50731 15.2944 8.6064 15.3936L8.6892 15.4632C8.80477 15.5431 8.94471 15.5799 9.08461 15.5671C9.22452 15.5544 9.35552 15.493 9.4548 15.3936L12 12.8496L14.5452 15.3936L14.6292 15.4632C14.7447 15.5428 14.8843 15.5794 15.024 15.5666C15.1636 15.5539 15.2944 15.4927 15.3936 15.3936L15.4632 15.3108C15.5431 15.1953 15.5798 15.0553 15.5671 14.9154C15.5544 14.7755 15.493 14.6445 15.3936 14.5452L12.8496 12L15.3936 9.45482L15.4632 9.37082C15.5427 9.25536 15.5793 9.11568 15.5666 8.97604C15.5539 8.8364 15.4927 8.70563 15.3936 8.60642L15.3108 8.53682C15.1952 8.45696 15.0553 8.42019 14.9154 8.43291C14.7755 8.44562 14.6445 8.50703 14.5452 8.60642L12 11.1504L9.4548 8.60642L9.372 8.53682Z" />
      </svg>
    );
  },
);

DismissCircleFilled.displayName = 'DismissCircleFilled';

export { DismissCircleFilled, dismissCircleFilledVariants };
